import { useEffect } from 'react';

import { useCart } from '@sola/cart-sdk/store.js';
import { trackError } from '@sola/cookies/components/datalayer.js';

import { useDonate } from '../donate-context';
import { useDonateErrors } from './use-donate-errors';

let cartFetched = false;
let listenersAdded = false;

export const useDonateValidation = () => {
  const { state, config } = useDonate();
  const { translateDonateError } = useDonateErrors();
  const {
    actions: { getCart },
  } = useCart('actions', 'cart');

  const getCurrentAmount = () => {
    if (state.otherSelected) {
      return state.otherAmounts[state.donateFrequency];
    }
    return state.selectedAmounts[state.donateFrequency];
  };

  const getValidationState = () => {
    const amount = getCurrentAmount();
    const numericAmount = Number(amount);

    if (!amount) {
      return {
        isValid: false,
        isDisabled: false,
        message: undefined,
      };
    }

    if (state.submitError) {
      trackError(state.submitError.toString());
      return {
        isValid: false,
        isDisabled: true,
        message: state.submitError,
      };
    }

    const meetsThreshold = numericAmount >= config.donationLimits.min;
    if (!meetsThreshold) {
      trackError(translateDonateError('ITEM_MIN').message.toString());
      return {
        isValid: false,
        isDisabled: true,
        message: translateDonateError('ITEM_MIN'),
      };
    }

    const withinMax = numericAmount <= config.donationLimits.max;
    if (!withinMax) {
      trackError(translateDonateError('ITEM_MAX').message.toString());
      return {
        isValid: false,
        isDisabled: true,
        message: translateDonateError('ITEM_MAX'),
      };
    }

    return {
      isValid: true,
      isDisabled: false,
      message: undefined,
    };
  };

  useEffect(() => {
    const refreshCart = () => {
      if (getCart) {
        getCart();
        cartFetched = true;
      }
    };

    const handleFocus = () => {
      refreshCart();
    };

    const handleBeforeUnload = () => {
      cartFetched = false;
    };

    if (!cartFetched && getCart !== undefined) {
      refreshCart();
    }

    if (!listenersAdded && getCart !== undefined) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('focus', handleFocus);
      listenersAdded = true;
    }
  }, [getCart]);

  const validationState = getValidationState();

  return {
    getCurrentAmount,
    getValidationState,
    validationState,
  };
};
